import { defineFakeRoute } from "vite-plugin-fake-server/client";

export default defineFakeRoute([
  {
    url: "/workflow/category/list",
    method: "get",
    response: () => {
      const rows = [
        {
          categoryId: "1866400732030353410",
          categoryName: "测试",
          code: "111",
          remark: "1111"
        },
        {
          categoryId: "1868488519076454402",
          categoryName: "12",
          code: "12",
          remark: "测试"
        }
      ];
      return {
        success: true,
        data: {
          rows
        }
      };
    }
  }
]);
